var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"carregando"},[_c('i',{staticClass:"fa fa-refresh fa-spin"}),_vm._v(" "+_vm._s(_vm._traducao('global','carregando'))+"...\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }